export const GAME_DISPLAY_PREFERENCE = {
  AIRSOFT_ONLY: 'airsoft',
  PAINTBALL_ONLY: 'paintball',
  SPEEDBALL_ONLY: 'speedball',
  ALL_GAMES: 'all'
} as const;

export const GAME_DISPLAY_PREFERENCE_LABELS = {
  [GAME_DISPLAY_PREFERENCE.AIRSOFT_ONLY]: 'Airsoft Only',
  [GAME_DISPLAY_PREFERENCE.PAINTBALL_ONLY]: 'Paintball Only',
  [GAME_DISPLAY_PREFERENCE.SPEEDBALL_ONLY]: 'Speedball Only',
  [GAME_DISPLAY_PREFERENCE.ALL_GAMES]: 'All Games'
} as const;

export const GAME_DISPLAY_PREFERENCE_OPTIONS = [
  { value: GAME_DISPLAY_PREFERENCE.ALL_GAMES, label: GAME_DISPLAY_PREFERENCE_LABELS[GAME_DISPLAY_PREFERENCE.ALL_GAMES] },
  { value: GAME_DISPLAY_PREFERENCE.AIRSOFT_ONLY, label: GAME_DISPLAY_PREFERENCE_LABELS[GAME_DISPLAY_PREFERENCE.AIRSOFT_ONLY] },
  { value: GAME_DISPLAY_PREFERENCE.PAINTBALL_ONLY, label: GAME_DISPLAY_PREFERENCE_LABELS[GAME_DISPLAY_PREFERENCE.PAINTBALL_ONLY] },
  { value: GAME_DISPLAY_PREFERENCE.SPEEDBALL_ONLY, label: GAME_DISPLAY_PREFERENCE_LABELS[GAME_DISPLAY_PREFERENCE.SPEEDBALL_ONLY] }
];

export type GameDisplayPreference = typeof GAME_DISPLAY_PREFERENCE[keyof typeof GAME_DISPLAY_PREFERENCE]; 